export class UserRoleModel {
    Id: number;
    UserId: number;
    RoleId: number;
}